module.exports = __webpack_public_path__ + "static/media/DSC01477.aca9ba0c.jpg";